
import { doctorService } from './doctorService';
import { patientService } from './patientService';
import api from './api';
import { toast } from '@/components/ui/sonner';

export const resetService = {
  // Reset data for doctors and patients
  resetMockData: async (): Promise<void> => {
    try {
      // Check if we're in development or production
      if (import.meta.env.PROD) {
        // In production, only use real API
        try {
          await api.post('/doctors/reset');
          await api.post('/patients/reset');
          console.log('Server data reset successfully');
          toast.success('Data reset successful', {
            description: 'All doctors and patients data has been reset to initial values'
          });
        } catch (apiError) {
          console.error('Error resetting data via API:', apiError);
          toast.error('Data reset failed', {
            description: 'Could not reset data. Please try again later.'
          });
          throw apiError; // In production, don't fall back to mock methods
        }
      } else {
        // In development, try API first but fall back to local methods
        try {
          // Try API first
          await api.post('/doctors/reset');
          await api.post('/patients/reset');
          console.log('Server data reset successfully');
          toast.success('Data reset successful', {
            description: 'All doctors and patients data has been reset to initial values'
          });
        } catch (apiError) {
          // If API fails in development, fall back to local methods
          console.warn('API reset failed, falling back to local reset methods', apiError);
          try {
            await doctorService.resetAll();
            await patientService.resetAll();
            console.log('Local data reset successfully as fallback');
            toast.success('Data reset successful', {
              description: 'All doctors and patients data has been reset to initial values (local data)'
            });
          } catch (localError) {
            console.error('Error resetting local data:', localError);
            toast.error('Data reset failed', {
              description: 'Could not reset local data. Please check console for details.'
            });
            throw localError;
          }
        }
      }
    } catch (error) {
      console.error('Error resetting data:', error);
      throw error;
    }
  }
};
